var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusSignGuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 95,
    viewBox: "0 0 89 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9946 47.5C54.0068 47.5 63.7446 37.7622 63.7446 25.75C63.7446 13.7378 54.0068 4 41.9946 4C29.9824 4 20.2446 13.7378 20.2446 25.75C20.2446 37.7622 29.9824 47.5 41.9946 47.5Z",
    stroke: "#0C7488",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7448 91H12.7019C11.4682 91.0003 10.2485 90.7381 9.12379 90.231C7.9991 89.7238 6.99514 88.9833 6.17853 88.0585C5.36192 87.1337 4.75135 86.0458 4.38732 84.867C4.0233 83.6882 3.91416 82.4454 4.06715 81.2212L5.76365 67.6318C6.15818 64.4746 7.69251 61.5704 10.0781 59.4652C12.4637 57.3599 15.5363 56.1988 18.718 56.2H20.2448M72.4448 51.85V77.95M59.3948 64.9H85.4948",
    stroke: "#0C7488",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSignGuy);
export default __webpack_public_path__ + "static/media/plusSignGuy.317ccc985834c1da794a132c185ca138.svg";
export { ForwardRef as ReactComponent };